import { reverseTicket, saveTicket } from "../../../networking/NetworkingTicket";

const getTicketRowsToSave = (ticketRows, ticketType) =>{

  const ticketRowsToSave = [] ;
  if(ticketRows)
  {
    ticketRows.forEach((o, index) =>{
      const newTicket = {
            ItemNo: index+1,
            RecipientType: ticketType === 'Incoming' ? null: o.RecipientType,
            RecipientID: ticketType === 'Incoming' ? null: o.RecipientID,
            CurrencyID: o.CurrencyID,
            Amount: o.Amount,
            Instrument: isNaN(o.Instrument) ? o.Instrument: 'Electronic Funds Transfer'  ,
            DeliveryMethod: o.DeliveryMethod,
            BankAccountID: isNaN(o.Instrument) ? null : Number(o.Instrument) 
        }
      ticketRowsToSave.push(newTicket);
      })
  }
  return ticketRowsToSave
}

const getTicketToSave = (objTicket, customerId, userID, ticketType , contactId)=>
{
    const ticketDate = new Date();

    return {
    TicketNo: objTicket.TicketNo > 0? objTicket.TicketNo : 0,
    IssueDate: ticketDate,
    CustomerID: customerId,
    ContactID: contactId,
    TicketType: ticketType,
    DeliveryDate: objTicket.DeliveryDate,
    Comments: objTicket.Comments,
    Status: "Accepted",
    UserId: userID,
    UpdateToken: objTicket.UpdateToken,
    Details: getTicketRowsToSave(objTicket.TicketRows, ticketType)
  }
}

export const save = async(objTicket, comments, customerId, userID, lockedSide, contactId, balances) =>{
   
  objTicket.Comments = comments;

  const ticket = getTicketToSave(objTicket, customerId, userID, lockedSide, contactId);
  const balancesToSave = balances.map((b) => {
    return {
      Currency: b.Currency,
      Balance: b.Balance$,
      UpdateToken: b.UpdateToken
    }
  });
  
  const model = {
    Ticket: ticket,
    Balances: balancesToSave
  }
  const responseSave = await saveTicket(model);

  console.log(responseSave);
  if(responseSave.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseSave.Message, Success: false, TicketNo:0}
  }
  else{
    const messageSave = ticket.TicketNo > 0 ?'Ticket was saved successfully': `Ticket was saved successfully. Ticket ID: ${responseSave.TicketNo} `
    return {Title: 'Success', Message: messageSave, Success: true, TicketNo: responseSave.TicketNo}
  }
}

export const reverseSave = async(ticketNo, comments, userID) =>{
   
  const responseSave = await reverseTicket(ticketNo, comments, userID);

  console.log(responseSave);
  if(responseSave.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseSave.Message, Success: false, TicketNo:0}
  }
  else{
    const messageSave = 'Ticket was reversed successfully';
    return {Title: 'Success', Message: messageSave, Success: true, TicketNo: responseSave.TicketNo}
  }
}